import {getFromBoomr} from 'utilities/product';

import {SpecialCaseThemeName} from './types';

export const MIN_PAYMENT_BUTTON_HEIGHT = 260;
export const MIN_PAYMENT_BUTTON_WIDTH = 250;
export const MIN_PAYMENT_BUTTON_PERCENTAGE_OF_PARENT = 0.6;

/**
 * @returns {boolean} true if the slot is tall enough or doesn't have a max-height
 */
export function validateSlotHeight(slot: Element): boolean {
  if (!slot) return false;

  const slotHeight = getComputedStyle(slot).maxHeight;

  if (slotHeight === 'none') return true;

  return parseInt(slotHeight, 10) >= MIN_PAYMENT_BUTTON_HEIGHT;
}

/**
 * @returns {boolean} true if the slot is wide enough
 */
export function validateSlotWidth(slot: Element): boolean {
  if (!slot) return false;

  const slotWidth = slot.getBoundingClientRect().width;

  return slotWidth > MIN_PAYMENT_BUTTON_WIDTH;
}

/**
 * @returns {boolean} true if the slot is part of a single column layout with the add to cart button
 */
export function validateSlotLayout(slot: Element): boolean {
  if (!slot) return false;

  const slotParent = getSlotParent(slot);

  if (!slotParent) return false;

  const slotWidth = slot.getBoundingClientRect().width;
  const slotParentWidth = slotParent.getBoundingClientRect().width;

  return slotWidth > slotParentWidth * MIN_PAYMENT_BUTTON_PERCENTAGE_OF_PARENT;

  function getSlotParent(slot: Element): Element | null {
    if (!slot.parentElement) return null;

    const themeName = getFromBoomr('themeName')?.toUpperCase() ?? null;

    switch (themeName) {
      case SpecialCaseThemeName.Story:
        return slot.parentElement.parentElement;
      default:
        return slot.parentElement;
    }
  }
}

/**
 * @returns {boolean} true if the slot is wide and tall enough and in a single column layout
 */
export function validateSlot(slot: Element): boolean {
  return (
    validateSlotHeight(slot) &&
    validateSlotWidth(slot) &&
    validateSlotLayout(slot)
  );
}
